import { HexColor } from "@mapmycustomers/shared/types/AnyColor";
import anyColorToHex from "@mapmycustomers/shared/util/color/anyColorToHex";

import cssColors from "@app/component/activity/_activityTypeColors.module.scss";

const CustomActivityTypeColor = {
  AMBER: cssColors.amber,
  COFFEE: cssColors.coffee,
  DENIM: cssColors.denim,
  FOREST: cssColors.forest,
  GRAPE: cssColors.grape,
  LATTE: cssColors.latte,
  LILAC: cssColors.lilac,
  MANDARIN: cssColors.mandarin,
  MAROON: cssColors.maroon,
  MIDNIGHT: cssColors.midnight,
  MOSS: cssColors.moss,
  OCEAN: cssColors.ocean,
  OLIVE: cssColors.olive,
  ORCHID: cssColors.orchid,
  PURPLE: cssColors.purple,
  ROYAL_BLUE: cssColors.royalBlue,
  SEAWEED: cssColors.seaweed,
  STONE: cssColors.stone,
  TERRACOTTA: cssColors.terracotta,
  WATERMELON: cssColors.watermelon,
};

export const colorToName = Object.entries(CustomActivityTypeColor).reduce(
  (result, [name, value]) => {
    // We have to use anyColorToHex here because SASS converts some colors to their names sometimes.
    // E.g., it can convert "#000080" to "navy", which is unwanted. So by using anyColorToHex, we're
    // ensuring that the keys will always be a HexColor.
    return Object.assign(result, { [anyColorToHex(value)]: name });
  },
  {} as Record<HexColor, string>
);

export default CustomActivityTypeColor;
